import axios from "axios"

interface ICheckStopSellParams {
    bookingId: string,
    pickupDate?: string,
    dropoffDate?: string
}

interface ICheckStopSellReturn {
    stopSell: boolean,
    ignore: boolean,
    stopOverbooking: boolean,
}

export const checkStopSell = async (params: ICheckStopSellParams): Promise<ICheckStopSellReturn> => {
    const body = (params.pickupDate && params.dropoffDate)
        ? { pickupDate: params.pickupDate, dropoffDate: params.dropoffDate }
        : undefined;
    const response = await axios.post(`/booking/book/${params.bookingId}/check-stop-sell`, body);
    return response.data;
}
